import { StaticElevationSvgJsx } from "../../components/ApartmentFinder/Components/SvgJSX"
import { FavouriteIcon } from "../../ApartmentFinderConfig/Icons/DynamicIcons"
// import { FavouriteIcon } from "../../ApartmentFinderConfig/Icons/DynamicIcons"
import { useStore } from "../../components/ApartmentFinder/State/Store"
// import { returnsBlockID } from "components/ApartmentFinder/Utils/Helpers"
import {
  useApartmentBedsByPlotNumber,
  useApartmentTypeByPlotNumber,
  useApartmentByFloorPlanCode,
  useBlockIDbyPlotNumber,
  useApartmentFloorLevelByPlotNumber,
  useApartmentBlockNameLevelByPlotNumber,
  useApartmentBathsLevelByPlotNumber,
  useIsHanded
} from "../../components/ApartmentFinder/Utils/hooks"

// import SVG from "react-inlinesvg"

import {
  FavouriteCardContainer,
  FloorPlan,
  FloorplanHolder,
  Header,
  InfoHolder,
  // ViggnetteHolder,
  TitleHolder,
  DimsHolder,
  ElevationHolder,
  Disclaimer,
  FloorTitle,
  Button,
  PlotTitle,
  BedTitle,
  HorizontalHolder,
  ButtonHolder,
  FullScreenFloor
} from "./FavouriteCard.style"
import Viewer360 from "../../components/Viewer360"
import { useEffect, useState } from "react"
import { isIOS } from "react-device-detect"
// import { CircleShape } from "../../ApartmentFinderConfig/UI/Shapes"
function FavouriteCard2({ id, showButtons = true, floor_no, hasEle = true }) {
  const [visible, setVisible] = useState(false)
  const fullScreenPlan = useStore(state => state.fullScreenPlan)
  const setFullScreenPlan = useStore(state => state.setFullScreenPlan)
  const favourites = useStore(state => state.favourites)
  const addFavourite = useStore(state => state.addFavourite)
  const removeFavourite = useStore(state => state.removeFavourite)
  const activeBlock = useStore(state => state.activeBlock)
  // const activeFloor = useStore(state => state.activeFloor)
  const activeApt = useStore(state => state.activeApt)
  const aspects = useStore(state => state.aspects)
  const selectedFavourite = useStore(state => state.selectedFavourite)
  const bedroomCounts = useStore(state => state.bedroomCounts)
  const show360 = useStore(state => state.show360)
  const setShow360 = useStore(state => state.setShow360)
  const setShowRecipient360 = useStore(state => state.setShowRecipient360)

  const flatType = useApartmentTypeByPlotNumber()[id]
  const floorPlanCode = useApartmentByFloorPlanCode()[id]
  const beds = useApartmentBedsByPlotNumber()[id]
  const floor = useApartmentFloorLevelByPlotNumber()[id]
  const block = useApartmentBlockNameLevelByPlotNumber()[id]
  const handed = useIsHanded()[activeApt]

  useEffect(() => {
    setShow360(false)
    setShowRecipient360(false)
    setTimeout(() => {
      setVisible(true)
      setShow360(false)
      setShowRecipient360(false)
    }, 10)

    return () => setFullScreenPlan(false)
  }, [])

  useEffect(() => {}, [
    id,
    floor,
    bedroomCounts,
    activeBlock,
    activeApt,
    aspects,
    favourites,
    selectedFavourite
  ])

  const addTerrace = (floor, flatType) => {
    return floor !== "1" &&
      (flatType.toLowerCase() === "e11" || flatType.toLowerCase() === "e10")
      ? "-t"
      : ""
  }

  const blockByID = useBlockIDbyPlotNumber()[id].split(".")[0]
  const numberofBaths = useApartmentBathsLevelByPlotNumber()[id]

  let isBlockD = blockByID === "D1" || blockByID === "D2" || blockByID === "D4"
  let isBlockC5 = blockByID === "C5"

  return (
    <>
      {fullScreenPlan && (
        <FullScreenFloor onClick={() => setFullScreenPlan(false)}>
          {isBlockD || isBlockC5 ? (
            <img
              style={{ transform: handed === "Opp" ? "scaleX(-1)" : null }}
              src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/images/floorplans/new/${floorPlanCode}.png`}
              alt={""}
            ></img>
          ) : (
            <img
              style={{ transform: handed === "Opp" ? "scaleX(-1)" : null }}
              src={`${
                process.env.PUBLIC_URL
              }/assets/apartmentfinder/images/floorplans/${flatType.toLowerCase()}${addTerrace(
                floor,
                flatType
              )}.jpg`}
              alt={""}
            ></img>
          )}
        </FullScreenFloor>
      )}
      <FavouriteCardContainer visible={visible ? 1 : 0}>
        <FloorplanHolder
          onClick={showButtons ? () => setFullScreenPlan(true) : null}
        >
          <Header />
          <FloorPlan>
            {isBlockD || isBlockC5 ? (
              <img
                style={{ transform: handed === "Opp" ? "scaleX(-1)" : null }}
                width="100%"
                height="100%"
                src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/images/floorplans/new/${floorPlanCode}.png`}
                alt={""}
              ></img>
            ) : (
              <img
                style={{ transform: handed === "Opp" ? "scaleX(-1)" : null }}
                width="100%"
                height="100%"
                src={`${
                  process.env.PUBLIC_URL
                }/assets/apartmentfinder/images/floorplans/${flatType.toLowerCase()}${
                  floor !== "1" &&
                  (flatType.toLowerCase() === "e11" ||
                    flatType.toLowerCase() === "e10")
                    ? "-t"
                    : ""
                }.jpg`}
                alt={""}
              ></img>
            )}
          </FloorPlan>
        </FloorplanHolder>

        <InfoHolder>
          {/* <CircleShape /> */}
          <TitleHolder>
            <FloorTitle>Floor {floor}</FloorTitle>
            <PlotTitle>PLOT {id}</PlotTitle>
            <BedTitle>
              {beds} Bed{beds === "1" ? "" : "s"}, {numberofBaths} Bath
              {numberofBaths === "1" ? "" : "s"}
            </BedTitle>
          </TitleHolder>
          <DimsHolder>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              viewBox="0 0 444 21.09"
            >
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                  <path
                    d="M.26,12.68,5.25,0H6.6l4.87,12.68H10.23l-1.46-4H3l-1.49,4Zm3.14-5h5L5.88,1Zm10.8.47a5.14,5.14,0,0,0,.21,1.48,4,4,0,0,0,.6,1.22,3.22,3.22,0,0,0,1,.83,2.77,2.77,0,0,0,1.3.3,3,3,0,0,0,1.41-.32,2.79,2.79,0,0,0,1-.9,3.84,3.84,0,0,0,.57-1.3,6.57,6.57,0,0,0,.14-1.62,4.4,4.4,0,0,0-.25-1.52A3.09,3.09,0,0,0,19.5,5.2a2.61,2.61,0,0,0-1-.69,2.94,2.94,0,0,0-1.23-.25,2.82,2.82,0,0,0-1.32.3,2.77,2.77,0,0,0-1,.83,3.71,3.71,0,0,0-.6,1.23A5.73,5.73,0,0,0,14.2,8.15Zm0,8.12H13.14V3.56H14.2v1.6h0a3.22,3.22,0,0,1,.58-.79,3.4,3.4,0,0,1,.8-.58,4.49,4.49,0,0,1,.89-.36,3.6,3.6,0,0,1,.9-.12,4.33,4.33,0,0,1,1.89.37,3.42,3.42,0,0,1,1.26,1,3.86,3.86,0,0,1,.74,1.52,7.07,7.07,0,0,1,.23,1.88,6.85,6.85,0,0,1-.24,1.83,4.58,4.58,0,0,1-.76,1.55,3.66,3.66,0,0,1-1.27,1.06,3.86,3.86,0,0,1-1.8.39,4.35,4.35,0,0,1-1.86-.42,3.39,3.39,0,0,1-1.39-1.29ZM29.75,7.89a5,5,0,0,1-1.35.37c-.46.06-.92.11-1.38.14a3.89,3.89,0,0,0-1.9.55,1.58,1.58,0,0,0-.67,1.39,1.72,1.72,0,0,0,.16.74,2,2,0,0,0,.44.51,2.22,2.22,0,0,0,.64.3,3.06,3.06,0,0,0,.74.09,5.06,5.06,0,0,0,1.23-.16,3.54,3.54,0,0,0,1.06-.48,2.67,2.67,0,0,0,.75-.82,2.45,2.45,0,0,0,.28-1.2ZM28,7.36l.7-.1a2.59,2.59,0,0,0,.69-.2.51.51,0,0,0,.31-.4,2.24,2.24,0,0,0,.07-.55,1.76,1.76,0,0,0-.52-1.32,2.39,2.39,0,0,0-1.75-.53,4.44,4.44,0,0,0-1,.11,1.91,1.91,0,0,0-1.38,1,2.78,2.78,0,0,0-.28,1H23.75A3.15,3.15,0,0,1,24.12,5,2.63,2.63,0,0,1,24.93,4a3.15,3.15,0,0,1,1.16-.53,5.45,5.45,0,0,1,1.41-.18,4.85,4.85,0,0,1,1.29.16A2.54,2.54,0,0,1,29.84,4a2,2,0,0,1,.71.86,3.14,3.14,0,0,1,.26,1.34v5a1.08,1.08,0,0,0,.21.8c.16.1.45.07.9-.09v.83l-.37.1a1.43,1.43,0,0,1-.46.07,2.42,2.42,0,0,1-.47-.05.88.88,0,0,1-.43-.16,1.35,1.35,0,0,1-.26-.32,1.42,1.42,0,0,1-.12-.4,2.45,2.45,0,0,1,0-.48,4.42,4.42,0,0,1-1.53,1.13,4.51,4.51,0,0,1-1.87.39,4.11,4.11,0,0,1-1.16-.16,3,3,0,0,1-1-.49,2.74,2.74,0,0,1-.67-.81,2.66,2.66,0,0,1-.24-1.17c0-1.55,1.06-2.46,3.18-2.74Zm6.7,5.32H33.62V3.56h1.06V5.27h0a3,3,0,0,1,1.12-1.52,3.49,3.49,0,0,1,1.85-.44V4.46a3,3,0,0,0-1.48.28,2.52,2.52,0,0,0-.93.81,3.56,3.56,0,0,0-.48,1.21,8.43,8.43,0,0,0-.12,1.45Zm8.27,0a4.37,4.37,0,0,0-.51.12,2.58,2.58,0,0,1-.7.09,1.74,1.74,0,0,1-1.22-.39,2,2,0,0,1-.4-1.43V4.44H38.83V3.56h1.29V1h1.05V3.56h1.71v.88H41.17v6.25c0,.22,0,.42,0,.58a1,1,0,0,0,.11.41.49.49,0,0,0,.26.23,1.78,1.78,0,0,0,.53.07,2,2,0,0,0,.42,0,3.12,3.12,0,0,0,.44-.09Zm2.61,0H44.51V3.56h1.05V4.93h0a2.75,2.75,0,0,1,1.16-1.2,3.38,3.38,0,0,1,1.66-.42,3.65,3.65,0,0,1,1.07.14,2.47,2.47,0,0,1,.74.39,1.78,1.78,0,0,1,.51.55,3.36,3.36,0,0,1,.35.68,3,3,0,0,1,1.22-1.32,3.54,3.54,0,0,1,1.76-.44,3,3,0,0,1,1.48.32,2.11,2.11,0,0,1,.86.81,3,3,0,0,1,.39,1.14,8.45,8.45,0,0,1,.11,1.34v5.76H55.85V6.38a2.53,2.53,0,0,0-.42-1.55,1.77,1.77,0,0,0-1.54-.57,2.5,2.5,0,0,0-1.12.27,2.52,2.52,0,0,0-.94.77,2.83,2.83,0,0,0-.3.55,5.79,5.79,0,0,0-.17.63c0,.22-.08.45-.11.67s0,.43,0,.62v4.91h-1V6.38a2.53,2.53,0,0,0-.42-1.55,1.78,1.78,0,0,0-1.54-.57,2.5,2.5,0,0,0-1.12.27,2.45,2.45,0,0,0-.94.77,2.38,2.38,0,0,0-.3.55,4.16,4.16,0,0,0-.17.63,5.2,5.2,0,0,0-.11.67c0,.22,0,.43,0,.62ZM65.92,7.49a3.86,3.86,0,0,0-.19-1.25,2.76,2.76,0,0,0-.55-1,2.33,2.33,0,0,0-.89-.68A2.8,2.8,0,0,0,63,4.26a2.77,2.77,0,0,0-1.25.27,2.88,2.88,0,0,0-.92.7,3.56,3.56,0,0,0-.6,1A5,5,0,0,0,60,7.49Zm-6,.88a5.45,5.45,0,0,0,.19,1.41,3.59,3.59,0,0,0,.57,1.14,3,3,0,0,0,1,.78A3.11,3.11,0,0,0,63,12a2.85,2.85,0,0,0,1.77-.55,2.57,2.57,0,0,0,1-1.55H67a6,6,0,0,1-.51,1.22,4.31,4.31,0,0,1-.79,1,3.45,3.45,0,0,1-1.13.63,4.61,4.61,0,0,1-1.51.23,4.55,4.55,0,0,1-1.89-.37,3.54,3.54,0,0,1-1.3-1A4.3,4.3,0,0,1,59.09,10a7.19,7.19,0,0,1-.25-1.89,6.11,6.11,0,0,1,.29-1.88A4.87,4.87,0,0,1,60,4.74,3.91,3.91,0,0,1,63,3.31,3.63,3.63,0,0,1,66,4.61a5.66,5.66,0,0,1,1.06,3.76Zm10.19,4.31h-1V3.56h1V4.83a7.22,7.22,0,0,1,1.31-1.1,3,3,0,0,1,1.63-.42,4,4,0,0,1,1.57.3,2.65,2.65,0,0,1,1.22,1,2.29,2.29,0,0,1,.39,1,9,9,0,0,1,.07,1.07v6H75.29V6.73a2.69,2.69,0,0,0-.55-1.85,2.31,2.31,0,0,0-1.81-.62,2.57,2.57,0,0,0-.9.16,2.5,2.5,0,0,0-.74.39,2.92,2.92,0,0,0-.55.56,2.68,2.68,0,0,0-.35.67,3.44,3.44,0,0,0-.19.85c0,.27,0,.56,0,.88Zm11.94,0a4.37,4.37,0,0,0-.51.12,2.6,2.6,0,0,1-.71.09,1.73,1.73,0,0,1-1.21-.39,2,2,0,0,1-.41-1.43V4.44H78V3.56h1.28V1h1.06V3.56H82v.88H80.32v6.25c0,.22,0,.42,0,.58a1,1,0,0,0,.1.41.56.56,0,0,0,.27.23,1.78,1.78,0,0,0,.53.07,2,2,0,0,0,.42,0,3.12,3.12,0,0,0,.44-.09Zm6.76,0V0h4.33c.35,0,.7,0,1,0a5.58,5.58,0,0,1,1,.12,4.34,4.34,0,0,1,1,.28A4.38,4.38,0,0,1,97.1,1a3.87,3.87,0,0,1,1,1.13,5.82,5.82,0,0,1,.63,1.39A6.77,6.77,0,0,1,99.11,5a9.71,9.71,0,0,1,.1,1.37,9.43,9.43,0,0,1-.09,1.29,7,7,0,0,1-.24,1.28,6.53,6.53,0,0,1-.48,1.2,4.6,4.6,0,0,1-.72,1,3.79,3.79,0,0,1-1,.79,5.08,5.08,0,0,1-1.09.48,7.47,7.47,0,0,1-1.18.23c-.41,0-.83,0-1.25,0Zm1.19-1h2.87a12,12,0,0,0,1.52-.09,4.5,4.5,0,0,0,1.46-.49,2.91,2.91,0,0,0,1-.86A4.63,4.63,0,0,0,97.57,9a5.77,5.77,0,0,0,.34-1.36A9.22,9.22,0,0,0,98,6.32a11,11,0,0,0-.09-1.39,5.35,5.35,0,0,0-.34-1.35,4.15,4.15,0,0,0-.67-1.18,3.12,3.12,0,0,0-1.09-.9,3.7,3.7,0,0,0-1.34-.39A13.51,13.51,0,0,0,92.92,1H90.05Zm11.21,1V3.56h1.06v9.12Zm-.05-11.11V0h1.16V1.57Zm4.71,11.11h-1.06V3.56h1.06V4.93h0a2.69,2.69,0,0,1,1.16-1.2,3.32,3.32,0,0,1,1.65-.42,3.73,3.73,0,0,1,1.08.14,2.47,2.47,0,0,1,.74.39,1.78,1.78,0,0,1,.51.55,3.36,3.36,0,0,1,.35.68,3,3,0,0,1,1.22-1.32,3.51,3.51,0,0,1,1.76-.44,3,3,0,0,1,1.48.32,2.17,2.17,0,0,1,.86.81,3,3,0,0,1,.39,1.14,8.45,8.45,0,0,1,.1,1.34v5.76h-1.05V6.38a2.46,2.46,0,0,0-.43-1.55,1.76,1.76,0,0,0-1.53-.57,2.54,2.54,0,0,0-1.13.27,2.5,2.5,0,0,0-.93.77,2.06,2.06,0,0,0-.3.55,5.79,5.79,0,0,0-.18.63c0,.22-.08.45-.1.67s0,.43,0,.62v4.91h-1.06V6.38a2.53,2.53,0,0,0-.42-1.55,1.76,1.76,0,0,0-1.53-.57,2.54,2.54,0,0,0-1.13.27,2.5,2.5,0,0,0-.93.77,2.06,2.06,0,0,0-.3.55,5.79,5.79,0,0,0-.18.63c0,.22-.08.45-.1.67s0,.43,0,.62Zm20.36-5.19a3.86,3.86,0,0,0-.19-1.25,2.76,2.76,0,0,0-.55-1,2.29,2.29,0,0,0-.9-.68,2.77,2.77,0,0,0-1.25-.27,2.8,2.8,0,0,0-1.25.27,2.84,2.84,0,0,0-.91.7,3.56,3.56,0,0,0-.6,1,4.25,4.25,0,0,0-.3,1.24Zm-6,.88a5.05,5.05,0,0,0,.19,1.41,3.59,3.59,0,0,0,.57,1.14,2.94,2.94,0,0,0,1,.78,3.18,3.18,0,0,0,1.34.28,2.86,2.86,0,0,0,1.78-.55,2.66,2.66,0,0,0,1-1.55h1.18a6,6,0,0,1-.51,1.22,4.1,4.1,0,0,1-.8,1,3.4,3.4,0,0,1-1.12.63,4.67,4.67,0,0,1-1.52.23,4.5,4.5,0,0,1-1.88-.37,3.66,3.66,0,0,1-1.31-1,4.28,4.28,0,0,1-.75-1.51,6.8,6.8,0,0,1-.25-1.89,6.11,6.11,0,0,1,.28-1.88,4.89,4.89,0,0,1,.83-1.53,3.72,3.72,0,0,1,1.32-1,3.86,3.86,0,0,1,1.76-.39,3.64,3.64,0,0,1,3,1.3,5.66,5.66,0,0,1,1.06,3.76Zm10.19,4.31h-1.06V3.56h1.06V4.83a7.17,7.17,0,0,1,1.3-1.1,3.1,3.1,0,0,1,1.64-.42,4,4,0,0,1,1.57.3,2.58,2.58,0,0,1,1.21,1,2.08,2.08,0,0,1,.39,1,7.3,7.3,0,0,1,.07,1.07v6h-1V6.73a2.74,2.74,0,0,0-.55-1.85,2.31,2.31,0,0,0-1.81-.62,2.57,2.57,0,0,0-.9.16,2.5,2.5,0,0,0-.74.39,2.65,2.65,0,0,0-.55.56,2.68,2.68,0,0,0-.35.67,3,3,0,0,0-.19.85,8,8,0,0,0,0,.88Zm9.35-2.85a2.7,2.7,0,0,0,.88,1.67,3.07,3.07,0,0,0,1.85.48,3.31,3.31,0,0,0,1-.14,2.25,2.25,0,0,0,.69-.37,1.65,1.65,0,0,0,.42-.55,1.52,1.52,0,0,0,.14-.63,1.14,1.14,0,0,0-.44-1,3,3,0,0,0-1.07-.51,11.24,11.24,0,0,0-1.41-.32,7.26,7.26,0,0,1-1.41-.4,2.86,2.86,0,0,1-1.09-.76A2,2,0,0,1,139,5.92a2.36,2.36,0,0,1,.83-1.87,3.53,3.53,0,0,1,2.38-.74A3.91,3.91,0,0,1,144.6,4a3,3,0,0,1,1.13,2.2h-1.07a2,2,0,0,0-.81-1.48,3,3,0,0,0-1.66-.44,2.35,2.35,0,0,0-1.53.44,1.38,1.38,0,0,0-.53,1.13,1.14,1.14,0,0,0,.42,1,4,4,0,0,0,1.1.53c.43.13.9.25,1.4.35a6.66,6.66,0,0,1,1.41.46,3,3,0,0,1,1.08.77,2,2,0,0,1,.44,1.38,2.28,2.28,0,0,1-1.06,2,3.41,3.41,0,0,1-1.18.49,5.66,5.66,0,0,1-1.48.18,3.81,3.81,0,0,1-1.44-.25,3,3,0,0,1-1.06-.65,3.15,3.15,0,0,1-.69-1,3.69,3.69,0,0,1-.28-1.21Zm8,2.85V3.56H149v9.12Zm-.06-11.11V0H149V1.57Zm7.43,11.36a4.8,4.8,0,0,1-1.66-.32,3.73,3.73,0,0,1-1.33-.9,4.33,4.33,0,0,1-.9-1.49,5.85,5.85,0,0,1-.34-2.1,6.26,6.26,0,0,1,.27-1.87,4.36,4.36,0,0,1,.79-1.53,3.72,3.72,0,0,1,1.32-1,4.63,4.63,0,0,1,3.72,0,3.72,3.72,0,0,1,1.32,1,4,4,0,0,1,.77,1.52,6.33,6.33,0,0,1,.27,1.88,6,6,0,0,1-.3,2,4.38,4.38,0,0,1-.87,1.52,3.72,3.72,0,0,1-1.33,1A4.24,4.24,0,0,1,155.28,12.93Zm3.1-4.81a6.15,6.15,0,0,0-.18-1.52,3.52,3.52,0,0,0-.54-1.21,2.71,2.71,0,0,0-.95-.83,3.12,3.12,0,0,0-1.43-.3,2.83,2.83,0,0,0-1.43.34,2.8,2.8,0,0,0-.95.86,3.62,3.62,0,0,0-.54,1.23,5.66,5.66,0,0,0-.18,1.43,6,6,0,0,0,.19,1.57,3.71,3.71,0,0,0,.6,1.21,2.69,2.69,0,0,0,1,.8,3.18,3.18,0,0,0,1.34.28,2.94,2.94,0,0,0,1.41-.32,2.83,2.83,0,0,0,1-.88,3.9,3.9,0,0,0,.54-1.23A5.66,5.66,0,0,0,158.38,8.12Zm4.12,4.56h-1.06V3.56h1.06V4.83a6.85,6.85,0,0,1,1.3-1.1,3.08,3.08,0,0,1,1.64-.42,4,4,0,0,1,1.56.3,2.61,2.61,0,0,1,1.22,1,2.29,2.29,0,0,1,.39,1,9,9,0,0,1,.07,1.07v6h-1.06V6.73a2.69,2.69,0,0,0-.55-1.85,2.3,2.3,0,0,0-1.81-.62,2.57,2.57,0,0,0-.9.16,2.54,2.54,0,0,0-1.28,1,2.72,2.72,0,0,0-.36.67,3.44,3.44,0,0,0-.19.85c0,.27,0,.56,0,.88Zm9.34-2.85a2.8,2.8,0,0,0,.88,1.67,3.09,3.09,0,0,0,1.85.48,3.37,3.37,0,0,0,1-.14,2.08,2.08,0,0,0,.68-.37,1.83,1.83,0,0,0,.43-.55,1.52,1.52,0,0,0,.14-.63,1.14,1.14,0,0,0-.44-1,3.1,3.1,0,0,0-1.08-.51,10.48,10.48,0,0,0-1.41-.32,7.69,7.69,0,0,1-1.41-.4,3,3,0,0,1-1.09-.76A2.08,2.08,0,0,1,171,5.92a2.36,2.36,0,0,1,.83-1.87,3.49,3.49,0,0,1,2.37-.74,3.94,3.94,0,0,1,2.4.67,3,3,0,0,1,1.13,2.2h-1.08a1.92,1.92,0,0,0-.81-1.48,2.89,2.89,0,0,0-1.65-.44,2.39,2.39,0,0,0-1.54.44,1.37,1.37,0,0,0-.52,1.13,1.14,1.14,0,0,0,.42,1,4,4,0,0,0,1.09.53c.44.13.91.25,1.41.35a6.85,6.85,0,0,1,1.41.46,3,3,0,0,1,1.07.77,2,2,0,0,1,.44,1.38,2.34,2.34,0,0,1-.28,1.16,2.44,2.44,0,0,1-.77.83,3.41,3.41,0,0,1-1.18.49,5.72,5.72,0,0,1-1.48.18,3.9,3.9,0,0,1-1.45-.25,3,3,0,0,1-1-.65,2.85,2.85,0,0,1-.69-1,3.46,3.46,0,0,1-.28-1.21Z"
                    stroke="#867696"
                    fill="#867696"
                    strokeWidth="0.6"
                  />
                  <path
                    d="M0,20.67H444"
                    fill="none"
                    stroke="#867696"
                    strokeWidth="1.5"
                  />
                </g>
              </g>
            </svg>
          </DimsHolder>
          <DimsHolder
            style={{
              flexDirection: "column",
              justifyContent: "flex-start"
            }}
          >
            <img
              style={{
                width: "100%",
                objectFit: "contain"
              }}
              src={`${
                process.env.PUBLIC_URL
              }/assets/apartmentfinder/images/floorplans/${flatType.toUpperCase()}.svg`}
              alt={`coming soon`}
            ></img>
          </DimsHolder>
          <HorizontalHolder>
            <ElevationHolder>
              {hasEle && (
                <StaticElevationSvgJsx
                  activeBlock={blockByID}
                  forCard={true}
                  isCard={true}
                  floor={String(floor)}
                />
              )}
            </ElevationHolder>
            {showButtons && (
              <ButtonHolder>
                <Button onClick={() => setShow360(true)}>
                  <img
                    alt=""
                    src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/views.svg`}
                  ></img>
                </Button>
                <Button onClick={() => setShow360(true)}>
                  <img
                    alt=""
                    src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/spec.svg`}
                  ></img>
                </Button>
                <Button
                  style={{ zIndex: 999999999 }}
                  onClick={
                    favourites.includes(id)
                      ? () => removeFavourite(id)
                      : () => addFavourite(id)
                  }
                >
                  <FavouriteIcon
                    outline={true}
                    // isFavourite={true}
                    isFavourite={favourites.includes(id)}
                    showNumber={false}
                  />
                </Button>
              </ButtonHolder>
            )}
          </HorizontalHolder>

          {showButtons && !isIOS && (
            <Disclaimer>
              <p>
                The floorplans depict a typical layout of this house type. For
                exact plot specification, details of external and internal
                finishes, dimensions and floorplan differences consult your
                sales executive. All dimensions are + or - 50mm and floorplans
                are not shown to scale. The kitchen layout and furniture
                positions are for indicative purposes only. White wardrobe with
                mirrored doors included to bedroom 1 only.
              </p>
            </Disclaimer>
          )}
        </InfoHolder>
        {show360 && (
          // <div style={{ position: "absolute" }}> {Number(floor)} </div>
          <Viewer360
            setShow={setShow360}
            block={block.charAt(0)}
            floor={floor}
          />
        )}
      </FavouriteCardContainer>
    </>
  )
}

export default FavouriteCard2
